export const monetaryErosionsTypeOrder = {
  annuel: 0,
  mensuel: 1,
  smic: 2,
};
